import { SideMenuItem } from '@/modules/layout/composables/useSideMenu/SideMenuItem'

export const sideMenuActions = [
  new SideMenuItem({
    name: 'menu.home',
    key: 'home',
    routeName: 'home',
    icon: 'location',
    readyForMobile: true,
    locationType: ['location', 'singleLocation']
  }),
  new SideMenuItem({
    name: 'menu.home',
    key: 'home',
    routeName: 'home',
    icon: 'location',
    readyForMobile: true,
    locationType: ['organization']
  }),
  new SideMenuItem({
    name: 'menu.customers',
    routeName: 'customers',
    key: 'customers',
    icon: 'people',
    readyForMobile: true,
    access: ['organizationManagementAccess'],
    locationType: ['organization', 'singleLocation']
  }),
  new SideMenuItem({
    name: 'menu.temporal-closures',
    routeName: 'temporalClosures',
    key: 'temporalClosures',
    icon: 'clockwise',
    readyForMobile: true,
    locationType: ['singleLocation', 'location']
  }),
  new SideMenuItem({
    name: 'menu.bookings-manager',
    routeName: 'bookingsManager',
    key: 'bookingsManager',
    icon: 'calendar',
    readyForMobile: true,
    locationType: ['singleLocation', 'location']
  }),
  new SideMenuItem({
    name: 'menu.payments',
    icon: 'ticket',
    readyForMobile: true,
    key: 'payments',
    access: ['locationManagerAccess'],
    locationType: ['location', 'singleLocation'],
    submenu: [
      new SideMenuItem({
        name: 'menu.processed-transactions',
        routeName: 'movementsList',
        key: 'movementsList',
        readyForMobile: true,
        locationType: ['location', 'singleLocation']
      }),
      new SideMenuItem({
        name: 'menu.payouts',
        routeName: 'payoutsList',
        key: 'payoutsList',
        subRoutes: ['payout'],
        readyForMobile: true,
        locationType: ['location', 'singleLocation']
      })
    ]
  }),
  new SideMenuItem({
    name: 'menu.promotions',
    routeName: 'promotions',
    key: 'promotions',
    icon: 'discount',
    readyForMobile: true,
    access: ['organizationManagementAccess'],
    products: ['pos', 'shop'],
    locationType: ['organization', 'singleLocation']
  }),
  new SideMenuItem({
    name: 'menu.catalog',
    icon: 'catalogs',
    key: 'catalog',
    access: ['editLocationCatalog', 'editOrganizationCatalog'],
    products: ['shop', 'pos', 'delivery'],
    locationType: ['organization', 'location', 'singleLocation'],
    submenu: [
      new SideMenuItem({
        name: 'menu.catalog-list',
        routeName: 'catalogs',
        key: 'catalogs',
        subRoutes: ['catalog'],
        locationType: ['organization', 'location', 'singleLocation']
      }),
      new SideMenuItem({
        name: 'menu.assign-catalogs',
        routeName: 'locationBrandCatalogs',
        key: 'locationBrandCatalogs',
        access: ['assignCatalog'],
        locationType: ['location', 'singleLocation']
      }),
      new SideMenuItem({
        name: 'menu.products',
        routeName: 'productsCatalog',
        key: 'productsCatalog',
        locationType: ['organization', 'location', 'singleLocation']
      }),
      new SideMenuItem({
        name: 'menu.modifiers',
        routeName: 'modifiersCatalog',
        key: 'modifiersCatalog',
        locationType: ['organization', 'location', 'singleLocation']
      }),
      new SideMenuItem({
        name: 'menu.combos',
        routeName: 'combosCatalog',
        key: 'combosCatalog',
        locationType: ['organization', 'location', 'singleLocation']
      }),
      new SideMenuItem({
        name: 'menu.translations',
        routeName: 'translations',
        key: 'translations',
        locationType: ['organization', 'singleLocation']
      })
    ]
  }),
  new SideMenuItem({
    name: 'menu.reports',
    icon: 'columns',
    key: 'reports',
    readyForMobile: true,
    access: ['reportsAccess'],
    locationType: ['organization', 'location', 'singleLocation'],
    submenu: [
      new SideMenuItem({
        name: 'menu.sales',
        key: 'sales-reports',
        collapsible: true,
        isBold: true,
        callback: () => {},
        readyForMobile: true,
        products: ['shop', 'pos', 'delivery', 'qr'],
        locationType: ['organization', 'location', 'singleLocation'],
        submenu: [
          new SideMenuItem({
            name: 'menu.billing',
            routeName: 'organizationReportBilling',
            key: 'organizationReportBilling',
            readyForMobile: true,
            locationType: ['organization']
          }),
          new SideMenuItem({
            name: 'menu.billing',
            routeName: 'simplifiedBillingReport',
            key: 'simplifiedBillingReport',
            readyForMobile: true,
            locationType: ['location', 'singleLocation']
          }),
          new SideMenuItem({
            name: 'menu.revenue-sources',
            routeName: 'revenueSources',
            key: 'revenueSources',
            readyForMobile: true,
            locationType: ['location', 'singleLocation']
          }),
          new SideMenuItem({
            name: 'menu.activity',
            routeName: 'activity',
            key: 'activity',
            readyForMobile: true,
            locationType: ['location', 'singleLocation']
          }),
          new SideMenuItem({
            name: 'menu.promotions',
            routeName: 'promotionsReport',
            key: 'promotionsReport',
            readyForMobile: true,
            products: ['pos', 'shop'],
            locationType: ['location', 'singleLocation']
          }),
          new SideMenuItem({
            name: 'menu.fraud',
            routeName: 'fraudReport',
            key: 'fraudReport',
            readyForMobile: true,
            locationType: ['location', 'singleLocation']
          })
        ]
      }),
      new SideMenuItem({
        name: 'menu.catalog',
        key: 'catalog-reports',
        collapsible: true,
        isBold: true,
        callback: () => {},
        readyForMobile: true,
        products: ['shop', 'pos', 'delivery', 'qr'],
        locationType: ['organization', 'location', 'singleLocation'],
        submenu: [
          new SideMenuItem({
            name: 'menu.products',
            routeName: 'productsOrganizationReport',
            key: 'productsOrganizationReport',
            readyForMobile: true,
            locationType: ['organization']
          }),
          new SideMenuItem({
            name: 'menu.modifiers',
            routeName: 'modifiersOrganizationReport',
            key: 'modifiersOrganizationReport',
            readyForMobile: true,
            locationType: ['organization']
          }),
          new SideMenuItem({
            name: 'menu.combos',
            routeName: 'combosOrganizationReport',
            key: 'combosOrganizationReport',
            readyForMobile: true,
            locationType: ['organization']
          }),
          new SideMenuItem({
            name: 'menu.products',
            routeName: 'productsLocationReport',
            key: 'productsLocationReport',
            readyForMobile: true,
            locationType: ['location', 'singleLocation']
          }),
          new SideMenuItem({
            name: 'menu.categories',
            routeName: 'categories',
            key: 'categories',
            readyForMobile: true,
            locationType: ['location', 'singleLocation']
          }),
          new SideMenuItem({
            name: 'menu.modifiers',
            routeName: 'modifiersLocationReport',
            key: 'modifiersLocationReport',
            readyForMobile: true,
            locationType: ['location', 'singleLocation']
          }),
          new SideMenuItem({
            name: 'menu.combos',
            routeName: 'combosLocationReport',
            key: 'combosLocationReport',
            readyForMobile: true,
            locationType: ['location', 'singleLocation']
          })
        ]
      }),
      new SideMenuItem({
        name: 'menu.performance',
        key: 'performance-reports',
        collapsible: true,
        isBold: true,
        readyForMobile: true,
        callback: () => {},
        locationType: ['organization', 'location', 'singleLocation'],
        submenu: [
          new SideMenuItem({
            name: 'menu.your-restaurant',
            routeName: 'your-restaurant',
            key: 'your-restaurant',
            readyForMobile: true,
            locationType: ['location', 'singleLocation']
          }),
          new SideMenuItem({
            name: 'menu.daily-analytics',
            routeName: 'daily-analytics',
            key: 'daily-analytics',
            readyForMobile: true,
            products: ['shop', 'pos', 'delivery', 'qr'],
            locationType: ['organization', 'location', 'singleLocation'],
            featureFlag: 'daily-analytics'
          }),
          new SideMenuItem({
            name: 'menu.reservations-report',
            routeName: 'reservations',
            key: 'reservations',
            readyForMobile: true,
            locationType: ['location', 'singleLocation']
          }),
          new SideMenuItem({
            name: 'menu.attendance',
            routeName: 'attendance',
            key: 'attendance',
            readyForMobile: true,
            products: ['attendance'],
            locationType: ['location', 'singleLocation']
          }),
          new SideMenuItem({
            name: 'menu.employees',
            routeName: 'employeesReport',
            key: 'employeesReport',
            readyForMobile: true,
            products: ['shop', 'pos', 'delivery', 'qr'],
            locationType: ['location', 'singleLocation']
          }),
          new SideMenuItem({
            name: 'menu.delivery-times',
            routeName: 'deliveryOrderStatusesReport',
            key: 'deliveryOrderStatusesReport',
            products: ['shop', 'pos', 'delivery', 'qr'],
            locationType: ['location', 'singleLocation']
          }),
          new SideMenuItem({
            name: 'menu.ratings',
            routeName: 'ratings',
            key: 'ratings',
            readyForMobile: true,
            locationType: ['organization', 'singleLocation']
          }),
          new SideMenuItem({
            name: 'menu.ratings',
            routeName: 'ratingsLocationReport',
            key: 'ratingsLocationReport',
            readyForMobile: true,
            locationType: ['location']
          })
        ]
      }),
      new SideMenuItem({
        name: 'menu.financial-records',
        key: 'financial-records-reports',
        collapsible: true,
        isBold: true,
        callback: () => {},
        readyForMobile: true,
        products: ['shop', 'pos', 'delivery', 'qr'],
        locationType: ['organization', 'location', 'singleLocation'],
        submenu: [
          new SideMenuItem({
            name: 'menu.tabs',
            routeName: 'tabsOrganizationReport',
            key: 'tabsOrganizationReport',
            readyForMobile: true,
            locationType: ['organization']
          }),
          new SideMenuItem({
            name: 'menu.tabs',
            routeName: 'tabsLocationReport',
            key: 'tabsLocationReport',
            readyForMobile: true,
            locationType: ['location', 'singleLocation']
          }),
          new SideMenuItem({
            name: 'menu.tills',
            routeName: 'cashReport',
            key: 'cashReport',
            locationType: ['location', 'singleLocation']
          }),
          new SideMenuItem({
            name: 'menu.invoices',
            routeName: 'invoices',
            key: 'invoices',
            readyForMobile: true,
            locationType: ['organization', 'singleLocation']
          }),
          new SideMenuItem({
            name: 'menu.invoices',
            routeName: 'invoicesLocationReport',
            key: 'invoicesLocationReport',
            readyForMobile: true,
            locationType: ['location']
          }),
          new SideMenuItem({
            name: 'menu.movements',
            routeName: 'movements',
            key: 'movements',
            readyForMobile: true,
            locationType: ['organization', 'singleLocation']
          }),
          new SideMenuItem({
            name: 'menu.movements',
            routeName: 'movementsLocationReport',
            key: 'movementsLocationReport',
            readyForMobile: true,
            locationType: ['location']
          }),
          new SideMenuItem({
            name: 'menu.predefined-reports',
            routeName: 'predefinedReports',
            key: 'predefinedReports',
            readyForMobile: true,
            locationType: ['singleLocation', 'organization', 'location']
          })
        ]
      }),
      new SideMenuItem({
        name: 'menu.explore',
        routeName: 'explore',
        key: 'explore',
        readyForMobile: true,
        isBold: true,
        locationType: ['organization', 'singleLocation']
      }),
      new SideMenuItem({
        name: 'reporting.custom-reports',
        key: 'customReports',
        type: 'cta',
        ctaText: 'reporting.add',
        collapsible: false,
        isBold: true,
        callback: () => {},
        locationType: ['organization', 'singleLocation'],
        submenu: []
      })
    ]
  }),
  new SideMenuItem({
    name: 'hardware-store.ctas.title',
    icon: 'screen',
    key: 'hardwareStore',
    routeName: 'hardwareStore',
    access: ['organizationManagementAccess'],
    locationType: ['location', 'singleLocation'],
    products: ['hardwareStore'],
    readyForMobile: true,
    countries: ['!MX']
  })
]
